import { render, staticRenderFns } from "./BaseButtonCascader.vue?vue&type=template&id=81bf57c0&scoped=true&"
import script from "./BaseButtonCascader.vue?vue&type=script&lang=js&"
export * from "./BaseButtonCascader.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonCascader.vue?vue&type=style&index=0&id=81bf57c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bf57c0",
  null
  
)

export default component.exports